import { computed, ref } from 'vue';
import { useHCommon } from './use-page-common';
import { IBulletin } from '@/shared/interfaces/IBulletin';

export function useHBulletin(workspaceSlug: string, term: string = `workspace:${workspaceSlug}`) {
  const { hHttpRequest } = useHCommon();
  const acknowledgedBulletins = ref<string[]>([]);

  const { data: _bulletins } = hHttpRequest<IBulletin[]>({
    url: '/my/bulletins',
    params: {
      workspace: workspaceSlug,
      term: term,
      sort: 'order',
      sortby: 'desc',
    },
    isLive: true,
  });

  const bulletins = computed(() => {
    return _bulletins?.value
      ? _bulletins.value.filter((bulletin) => {
          return !acknowledgedBulletins.value.includes(bulletin.key);
        })
      : [];
  });

  async function acknowledgeBulletin(bulletinKey: string) {
    const { response } = hHttpRequest({
      url: `/my/bulletins/aknowledge/${bulletinKey}`,
      method: 'post',
    });

    const res = await response();

    if (!!res && res.ok) {
      acknowledgedBulletins.value.push(bulletinKey);
      return true;
    }

    return false;
  }

  return { bulletins, acknowledgeBulletin };
}
